export const selectEmployeeOccupation = {
    bindings: {
        identifier: '@'
    },
    template: require('./select-employee-occupation.html'),
    controller: 'SelectEmployeeOccupationController'
};
